<template>
    <el-row justify="center" style="margin-top:2rem;">
        <el-col :span="24">
            <div class="small text-center text-muted">
                &copy; 2023-2025 helloworldend.top 版权所有
            </div>
        </el-col>
    </el-row>
</template>